// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1touE","content":"Consent_content__2lhn-","footer":"Consent_footer__3c2qI"};